import { Mnemonic } from 'constants/mnemonics';
import {
  wellHomeOperationalPlotsBLUE,
  wellHomeOperationalPlotsBROWN,
  wellHomeOperationalPlotsGOLD,
  wellHomeOperationalPlotsGREEN,
  wellHomeOperationalPlotsHAWAIIBLUE,
  wellHomeOperationalPlotsLIGHTGREEN,
  wellHomeOperationalPlotsORANGE,
  wellHomeOperationalPlotsPINK,
  wellHomeOperationalPlotsPINKRED,
  wellHomeOperationalPlotsPRUPLE,
  wellHomeOperationalPlotsRED,
  wellHomeOperationalPlotsSANDYBROWN,
  wellHomeOperationalPlotsSHAMPOO,
  wellHomeOperationalPlotsWHITE,
  wellHomeOperationalPlotsYELLOW,
} from 'constants/plotly';
import { Dash } from 'plotly.js/lib/index-basic';

export type WellHomeSingleLineChartPlotlyConfig = {
  key: string;
  mnemonic: Mnemonic;
  rangeByWellbore: Record<string, [number | null, number | null]>;
  color: ColorOptionType;
  lineStyle: Dash;
};

export type WellHomeSingleSubplotPlotlyConfig =
  | []
  | [WellHomeSingleLineChartPlotlyConfig]
  | [WellHomeSingleLineChartPlotlyConfig, WellHomeSingleLineChartPlotlyConfig]
  | [
      WellHomeSingleLineChartPlotlyConfig,
      WellHomeSingleLineChartPlotlyConfig,
      WellHomeSingleLineChartPlotlyConfig,
    ];

export type WellHomePlotlyConfig = [
  WellHomeSingleSubplotPlotlyConfig,
  WellHomeSingleSubplotPlotlyConfig,
  WellHomeSingleSubplotPlotlyConfig,
  WellHomeSingleSubplotPlotlyConfig,
  WellHomeSingleSubplotPlotlyConfig,
];

export enum StyleOptionValues {
  SOLID = 'solid',
  DASH = 'dash',
  DOT = 'dot',
}

export const Colors = {
  BLUE: wellHomeOperationalPlotsBLUE,
  ORANGE: wellHomeOperationalPlotsORANGE,
  GREEN: wellHomeOperationalPlotsGREEN,
  WHITE: wellHomeOperationalPlotsWHITE,
  RED: wellHomeOperationalPlotsRED,
  YELLOW: wellHomeOperationalPlotsYELLOW,
  PINK: wellHomeOperationalPlotsPINK,
  PINKRED: wellHomeOperationalPlotsPINKRED,
  PRUPLE: wellHomeOperationalPlotsPRUPLE,
  SHAMPOO: wellHomeOperationalPlotsSHAMPOO,
  GOLD: wellHomeOperationalPlotsGOLD,
  BROWN: wellHomeOperationalPlotsBROWN,
  SANDYBROWN: wellHomeOperationalPlotsSANDYBROWN,
  HAWAIIBLUE: wellHomeOperationalPlotsHAWAIIBLUE,
  LIGHTGREEN: wellHomeOperationalPlotsLIGHTGREEN,
} as const;

export type ColorOptionType = keyof typeof Colors;

export const getCssLineStyleFromPlotlyDashStyle = (plotlyLineStyle: Dash) => {
  switch (plotlyLineStyle) {
    case 'dot':
      return 'dotted';
    case 'dash':
      return 'dashed';
    default:
      return 'solid';
  }
};
